/* eslint-env es6 */
/* eslint-disable no-restricted-syntax */

const size = 32;

export class Bitmask {
	constructor(mask = 0) {
		this.mask = mask;
	}

	/**
	 * Builds a bitmask from an array containing elements using a boolean filter
	 * @param array {any[]} Type of `array` must match the type of the input for
	 *      `boolEval`
	 * @param boolEval {(any)=>bool} Function that evaluates the elements of
	 *      array to boolean; default assumes the elements already eval to bool
	 */
	constructMaskFromElements(array, boolEval = (x) => x) {
		if (!Array.isArray(array)) {
			console.error("E_TYPE", `Expected array! Got ${typeof array}.`);
			return;
		}
		const len = array.length;
		if (len > size || len < 1) {
			console.error(
				"E_RANGE",
				`Provided array has length of ${len}! Expected 0 < length < ${size}`
			);
			return;
		}
		this.wipe();

		for (const [i, v] of array.entries()) {
			const bit = +!!boolEval(v);
			this.store(bit << i);
		}
	}

	/**
	 * Iterate through an array with the same length as the mask, executing a
	 * function on the elements where the corresponding bit in the stored mask
	 * is set
	 *
	 * IMPORTANT: `Bitmask` doesn't know how long your mask is, so it can't
	 * tell you if it is the same length or not!
	 *
	 * @param array {any[]} Type of array must match the type of the input for
	 *      `onSet`
	 * @param onSet {(any)=>void} Function that executes on each element of
	 *      `array` if its corresponding bit is set in the stored mask
	 */
	iterate(array, onSet) {
		if (!Array.isArray(array)) {
			console.error("E_TYPE", `Expected array! Got ${typeof array}.`);
			return;
		}
		const len = array.length;
		if (len > size || len < 1) {
			console.error(
				"E_RANGE",
				`Provided array has length of ${len}! Expected 0 < length < ${size}`
			);
			return;
		}

		for (const [i, v] of array.entries()) {
			if (!this.test(1 << i)) {
				continue;
			}

			onSet(v);
		}
	}

	/**
	 * Sets the bits in the stored mask that are set in the input mask
	 * @param mask {number}
	 */
	store(mask) {
		this.mask |= mask;
	}

	/**
	 * Clears the bits in the stored mask that are set in the input mask
	 * @param mask {number}
	 */
	clear(mask) {
		this.mask &= ~mask;
	}

	/**
	 * Inverts the bits in the stored mask that are set in the input mask
	 * @param mask {number}
	 */
	flip(mask) {
		this.mask ^= mask;
	}

	/**
	 * Returns `true` if all bits that are set in the input mask are also set
	 * in the stored mask
	 * @param mask {number}
	 */
	test(mask) {
		return (this.mask & mask) === mask;
	}

	/**
	 * Returns `true` if any bit set in the input mask is set in the stored
	 * mask
	 * @param mask {number}
	 */
	any(mask) {
		return (this.mask & mask) !== 0;
	}

	/**
	 * Clears every bit of the stored mask
	 */
	wipe() {
		this.mask = 0;
	}
}
